import moment from 'moment';

class ShippingService {
    /*@ngInject*/
    constructor() {
        this.overnightShippingCutoff = 15;
        this.date = moment();
        this.weekday = this.date.day() > 0 && this.date.day() < 5;
        this.friday = this.date.day() > 4 && this.date.day() < 6;
        this.weekend = this.date.day() < 1 || this.date.day() > 5;
    }

    isPastFourEastern() {
        return this.date.tz('America/New_York').startOf('hour').hour() > this.overnightShippingCutoff;
    }

    isOvernight(method) {
        return method.optionName === 'Overnight';
    }

    isWeekdayOvernight(method) {
        return (this.isOvernight(method) && this.weekday && this.isPastFourEastern());
    }

    isWeekendOvernight(method) {
        return (this.isOvernight(method) && (this.weekend || (this.friday && this.isPastFourEastern())));
    }
}
       
export default ShippingService;